<template>
    <div :class="['dimmer', loading ? 'active' : '']">
        <div class="loader"></div>
        <div >
            <form class="d-flex row mb-4 align-items-center">
                <div class=" col-lg-3 input-group py-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text "><i class="fas fa-search"></i></span>
                    </div>
                    <input
                        type="text"
                        class="form-control"
                        v-model="tempSearchQuery"
                        placeholder="Search..."
                    />
                </div>
                <div class="col-lg-3  col-6 input-group py-1">
                    <input
                        type="date"
                        class="form-control"
                        v-model="tempStartDate"
                        placeholder="Start Date"
                    />
                </div>
                <div class="col-lg-3 col-6   input-group py-1">
                    <input
                        type="date"
                        class="form-control"
                        v-model="tempEndDate"
                        placeholder="End Date"
                    />
                </div>

                <div class="col-lg-2 col-6 py-1">
                    <select @change="applyFilters" v-model="data.filters.size" class="custom-select" required>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="col-lg-1 col-6  py-1">
                    <button
                        @click.prevent="applyFilters"
                        :class="['btn btn-primary btn-sm text-white px-3 shadow-none', loading ? 'btn-loading' : '']"
                    >
                        <i class="fas fa-arrow-alt-circle-right"></i>
                    </button>
                </div>

            </form>

        </div>

        <div class="dimmer-content">
            <div class="bg-light shadow-sm rounded py-4 mb-4">


                <div class="d-flex justify-content-center align-items-center mb-4">
                    <h3 class="text-4 font-weight-400 d-flex align-items-center px-4 mb-0">
                        <strong> {{ data.event.name }}</strong>
                    </h3>
                    <button
                        class="btn btn-outline-primary btn-sm shadow-none ml-auto mr-2"
                        @click="downloadStatement"
                    >
                        <i class="fas fa-download mr-2"></i>Report
                    </button>
                </div>
                <transition name="shake">
                    <small v-if="message" class="alert alert-danger center-text">{{ message }}</small>
                </transition>
                <div class="table-container">
                    <div class="d-none d-sm-flex transaction-title py-2 px-2 border-bottom ">
                        <div class="col-2">Ref</div>
                        <div class="col-4">Email</div>
                        <div class="col-2">Amount</div>
                        <div class="col-2">Created At</div>
                        <div class="col-2 text-right"></div>
                    </div>

                    <div v-for="(row, index) in data.tickets" :key="index" :class="{ 'highlighted-row': selectedRow === index }" class="d-flex flex-column border-bottom py-3 px-2">
                        <!--Desktop-->
                        <div class="d-none d-sm-flex  align-items-center">
                            <div class="col-lg-2">#{{ row.reference }}</div>
                            <div class="col-lg-4">{{ row.email }}</div>
                            <div class="col-lg-2">{{ row.currency +" "+ money(row.total) }}</div>
                            <div class="col-lg-2">{{ row.created_at }}</div>
                            <div class="col-lg-2 text-right">
                                <button
                                    class="btn btn-link p-0"
                                    @click="toggleRow(index)"
                                    aria-expanded="selectedRow === index"
                                    :aria-controls="`collapse-${index}`"
                                >
                                    <small>{{ selectedRow === index ? 'Less' : 'More'}}</small>
                                    <i :class="selectedRow === index ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                </button>
                            </div>
                        </div>
                        <!--Desktop-->
                        <!--Mobile-->
                        <div class="d-flex d-sm-none row align-items-center px-2">
                            <div class="col-10">
                                <div class="row">
                                    <div class="col-8"><b>Rf:</b> {{ row.reference }}</div>
                                    <div class="col-4"><b>{{ row.currency +" "+ money(row.total) }}</b></div>
                                </div>
                                <div class="row">
                                    <div class="col-8">{{ row.email }}</div>
                                    <div class="col-4">{{ new Date(row.created_at).toLocaleDateString() }}</div>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="text-center">
                                    <button
                                        class="btn btn-link p-0"
                                        @click="toggleRow(index)"
                                        aria-expanded="selectedRow === index"
                                        :aria-controls="`collapse-${index}`"
                                    >
                                        <i :class="selectedRow === index ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!--Mobile-->
                        <!--Hidden Info-->
                        <transition name="slide-in-left">
                            <div v-if="selectedRow === index" :id="`collapse-${index}`" class="bg-light p-3 mt-3">
                                <div class="row">
                                    <div class="col-lg-6 col-12 text-3 py-2"><strong>Reference:</strong> {{ row.reference || 'N/A' }}</div>
                                    <div class="col-lg-6 col-12 text-3 py-2"><strong>Amount Paid:</strong> {{ row.currency +" "+ money(row.total) || 'N/A' }}</div>
                                    <div class="col-12"> <hr/></div>
                                    <div class="col-lg-6 col-12"><strong>Name:</strong> {{ row.name || 'N/A' }}</div>
                                    <div class="col-lg-6 col-12"><strong>Surname:</strong> {{ row.surname || 'N/A' }}</div>
                                    <div class="col-lg-6 col-12"><strong>Ticket Type:</strong> {{ row.type || 'N/A' }}</div>
                                    <div class="col-lg-6 col-12"><strong>Quantity:</strong> {{ row.quantity || 'N/A' }}</div>
                                    <div class="col-lg-6 col-12"><strong>Phone:</strong> {{ row.phone || 'N/A' }}</div>
                                    <div class="col-lg-6 col-12"><strong>Email:</strong> {{ row.email || 'N/A' }}</div>

                                    <div class="col-12"> <hr/></div>
                                    <!--
                                    <div class="col-lg-6 col-12"><strong>Message:</strong> {{ row.message || 'N/A' }}</div>
                                    <div class="col-12"> <hr/></div>-->
                                    <div class="col-lg-6 col-12 text-1"><strong>Payment Method:</strong> {{ row.payment || 'N/A' }}</div>
                                    <div class="col-lg-6 col-12 text-1"><strong>Payment Status:</strong> {{ row.state || 'N/A' }}</div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <!-- Pagination Controls -->
                <div class="d-flex align-items-center justify-content-between px-4">
                  <span class="text-black-50">
                    Showing {{ data.tickets.length }} of {{ data.pagination.total }} Records
                  </span>
                    <ul class="pagination justify-content-center mt-4 mb-0">
                        <li class="page-item" :class="{ disabled: data.pagination.current_page === 1 }">
                            <a class="page-link" href="#" tabindex="-1" @click.prevent="changePage(data.pagination.current_page - 1)">
                                <i class="fas fa-angle-left"></i>
                            </a>
                        </li>
                        <li class="page-item active">
                            <a
                                @click.prevent="loadMore"
                                v-if="data.pagination.total > data.tickets.length"
                                class="page-link" href="#"
                            >
                                Load More <span class="sr-only">(current)</span>
                            </a>
                        </li>
                        <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                            <span>...</span>
                        </li>
                        <li class="page-item" :class="{ disabled: data.pagination.current_page === totalPages }">
                            <a class="page-link" href="#" tabindex="-1" @click.prevent="changePage(data.pagination.current_page + 1)">
                                <i class="fas fa-angle-right"></i>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {money} from "../../../core/forms/money";
import Form from "../../../core/forms/form";


export default {
    mixins: [money],
    data() {
        return {
            loading: false,
            selectedRow: null,
            tempSearchQuery: '',
            tempStartDate: '',
            tempEndDate: '',
            message:'',
            form: new Form({
                startDate: '',
                endDate: ''
            }),
            data: {
                filters: {
                    search: '',
                    size: 10,
                    startDate: '',
                    endDate: '',
                },
                event:{},
                tickets: [],
                pagination: {
                    current_page: 1,
                    total: 0,
                    per_page: 10,
                    last_page: 1,
                },
            },
        };
    },
    computed: {
        totalPages() {
            return this.data.pagination.last_page;
        },
    },
    mounted() {
        this.fetchPayments();
    },
    methods: {
        fetchPayments() {
            this.loading = true;

            const params = {
                searchQuery: this.data.filters.search,
                size: this.data.filters.size,
                page: this.data.pagination.current_page,
                startDate: this.data.filters.startDate,
                endDate: this.data.filters.endDate,
            };

            window.axios
                .get(`/business/events/${this.$route.params.id}/api/report`, { params })
                .then((response) => {
                    const model = response.data.body.data;
                    this.data.event= model.event;
                    this.data.tickets = model.tickets;
                    this.data.pagination.total = model.total;
                    this.data.pagination.per_page = model.per_page;
                    this.data.pagination.current_page = model.current_page;
                    this.data.pagination.last_page = model.last_page;
                    this.loading = false;
                })
                .catch((error) => {
                    console.error("Error fetching filtered data:", error);
                    this.loading = false;
                });
        },
        downloadStatement() {
            this.message = '';
            if (!this.tempStartDate || !this.tempEndDate) {
                this.message = "Please set both the start date and end date before downloading the statement.";
                return;
            }
            const payload = {
                startDate: this.tempStartDate,
                endDate: this.tempEndDate,
            };
            axios.post(`/business/events/${this.$route.params.id}/api/generate-report`, payload, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `report_${new Date().toISOString().slice(0, 19)}.xlsx`;
                    link.click();
                })
                .catch((error) => {
                    console.error("Error downloading statement:", error);
                });
        },
        loadMore() {
            if (this.data.pagination.current_page < this.totalPages) {
                this.data.pagination.current_page++;
                const params = {
                    searchQuery: this.data.filters.search,
                    size: this.data.filters.size,
                    page: this.data.pagination.current_page,
                    startDate: this.data.filters.startDate,
                    endDate: this.data.filters.endDate,
                };
                this.loading = true;
                window.axios
                    .get(`/business/payments/${this.$route.params.id}/api/view`, { params })
                    .then((response) => {
                        const newPayments = response.data.body.model.payments;
                        this.data.payments = [...this.data.payments, ...newPayments];
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.error("Error loading more data:", error);
                        this.loading = false;
                    });
            }
        },
        applyFilters() {
            this.data.filters.search = this.tempSearchQuery;
            this.data.filters.startDate = this.tempStartDate;
            this.data.filters.endDate = this.tempEndDate;
            this.data.pagination.current_page = 1;
            this.data.payments = [];
            this.fetchPayments();
        },
        changePage(page) {
            if (page > 0 && page <= this.totalPages) {
                this.data.pagination.current_page = page;
                this.fetchPayments();
            }
        },
        toggleRow(index) {
            this.selectedRow = this.selectedRow === index ? null : index;
        },
    }
};
</script>

<style scoped>

.table-container {
    overflow-x: auto;
    white-space: nowrap;
}
.center-text {
    display: block;
    text-align: center;
}

.highlighted-row {
    background-color: #eee;
    border-left: 4px solid #2c0564;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
}
</style>
